/** Letters a decomposition does not reach — the API's table (R0030 WP-05). */
const LETTERS: Record<string, string> = {
  ß: 'ss',
  æ: 'ae',
  œ: 'oe',
  ø: 'o',
  ł: 'l',
  đ: 'd',
  ð: 'd',
  þ: 'th',
  ħ: 'h',
  ı: 'i',
};

const UMLAUTS: Record<string, string> = { ä: 'ae', ö: 'oe', ü: 'ue' };

/**
 * A URL key from a name, as the API makes one: lower-case ASCII, words joined by hyphens, German umlauts spelled
 * out. The API normalises and checks whatever is sent; this only fills the field for the user to see.
 */
export const slugify = (text: string, locale: string): string =>
  [...text.toLowerCase()]
    .map((character) => (locale === 'de' ? UMLAUTS[character] : undefined) ?? LETTERS[character] ?? character)
    .join('')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 128)
    .replace(/-+$/, '');
